module.exports = __webpack_public_path__ + "img/indus-pic-9.e3f2b2bd.png";